import { preloadPostOfficeScreenSpaceFlags } from '@atlassian/confluence-post-office-provider/entry-points/screen-space-flags-placement';

import { SSRMeasures } from '@confluence/action-measures';
import type { RouteMatch } from '@confluence/route';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools';

export async function preloadScreenSpaceFlags(match: RouteMatch | null) {
	const preloadedSessionContext = getPreloaderFnContext();
	const { userId } = preloadedSessionContext;
	if (!userId || !match) {
		return;
	}

	return SSRMeasures.run('ssr-app/prepare/preloadQuery/postOffice:ScreenSpaceFlags', async () => {
		return preloadPostOfficeScreenSpaceFlags(preloadedSessionContext, match);
	});
}
